<template>
    <div id="hero" class="direction-ltr">
        <div id="header">
            <!-- Header -->
            <a name="about"></a>
            <div class="intro-header">
                <div id="particles-js"></div>
                <div class="container">
                    <div class="row justify-content-between">
                        <div class="col-12 col-sm-12 col-md-12 col-lg-5 col-xl-5 order-lg-1 order-md-1">
                            <div class="intro-message">
                                <img class="main-logo mx-auto d-block" src="/img/hero/productive-white.svg" alt="logo Productive-labs פרודקטיב לאבס">
                                <h3>{{ $t('מקדמים אתכם במהירות של סטארטאפ') }}</h3>
                                <button v-scroll-to="'#contact-us'" class="btn btn-header">{{ $t('לקביעת פגישת ייעוץ') }}</button>
                            </div>
                        </div>
                        <div class="col-12 col-sm-12 col-md-12 col-lg-7 col-xl-7 order-lg-2 order-md-3">
                            <img id="welcome-img" class="img-responsive mx-auto d-block" src="img/about/technology.svg" alt="Productive-labs פרודקטיב לאבס about image">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import AnimatedCircles from '../AnimatedCircles.vue';

    export default {
        name: 'hero',
        components: {
            'animated-circles': AnimatedCircles,
        },
    }
</script>

<style lang="css" scoped>
    .intro-header {
        padding-top: 140px;
        position: relative;
        overflow: hidden;
        height: 800px;
        z-index: 1;
        display: block;
        content: "";
        padding-bottom: 50px;
        text-align: center;
        color: #f8f8f8;
        background: linear-gradient(to right top, rgba(65, 126, 170, 0.95), rgba(51, 122, 187, 0.95), rgba(60, 115, 202, 0.95), rgba(88, 104, 211, 0.95), rgba(124, 88, 213, 0.95), rgba(136, 76, 209, 0.95), rgba(149, 61, 203, 0.95), rgba(161, 40, 196, 0.95), rgba(151, 36, 192, 0.95), rgba(140, 32, 188, 0.95), rgba(130, 29, 184, 0.95), rgba(119, 25, 180, 0.95));
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
    }
    .intro-header:after {
        content: "";
        position: absolute;
        bottom: -100px;
        left: -50px;
        height: 200px;
        width: 130%;
        -webkit-transform: rotate(4deg);
        -ms-transform: rotate(4deg);
        transform: rotate(4deg);
        z-index: 10;
        background-image: linear-gradient(to bottom, #00c092, #00c092);
    }
    #welcome-img {
        height: auto;
        width: 90%;
    }
    .btn-header {
        height: 48px;
        min-width: 185px;
        color: #ffffff;
        font-weight: 500;
        border-radius: 22px 25px 22px 22px;
        cursor: pointer;
        background: linear-gradient(144deg, #00a5b7 10%, #00c092 65%);
        margin-top: 15px;
    }
    .intro-message {
        position: relative;
        padding-top: 100px;
        padding-bottom: 100px;
    }
    .intro-message h3 {
        font-size: 22px;
        font-family: inherit;
        font-weight: 300;
        padding-top: 10px;
    }
    h1 {
        margin: 0;
        text-shadow: 2px 2px 3px rgba(0,0,0,0.6);
        font-size: 5em;
    }
    .main-logo {
        width: 500px;
    }
    #header .img-responsive {
        padding-top: 40px;
    }

    @media(max-width:767px) {
        .intro-header {
            height: 1000px;
        }
        .main-logo {
            height: auto !important;
            width: 95%;
        }
        h1 {
            font-size: 34px;
        }
        li {
            display: block;
            margin-bottom: 20px;
            padding: 0;
        }
        li:last-child {
            margin-bottom: 0;
        }
        .intro-message {
            padding-bottom: 15%;
        }
        .intro-message h3 {
            font-size: 18px;
        }
        .btn-header {
            margin-top: 40px;
        }
    }
    @media(min-width:768px) {
        .main-logo {
            padding-top: 60px;
        }
    }
    .direction-ltr {
        direction: ltr !important;
    }
</style>
